export const RoutePaths = {
  mooringPlan: 'mooring-plan/:id/*',
  default: '*',
}
